module.exports = __webpack_public_path__ + "img/product3.7d8d48fa.png";